import { getStorage } from '@src/utils/storage'
import { GENERAL } from '@store/actionTypes'

export function restoreState() {
  return function (dispatch) {
    const state = getStorage()
    dispatch({ type: GENERAL.RESTORE_STATE, data: state })
  }
}
